import SideMenu from './side-menu';
import { BLOG_NAVBAR_CONTAINER, BLOG_SHOP_KETONE_BUTTON } from '../classnames/blog';

const Scroll = {
  up: 'up',
  down: 'down'
};

const SCROLL_AMOUNT_TO_HIDE_NAVBAR = 200;

const HIDDEN_NAVBAR_CLASS = 'navigation--blog--hidden';
const SHOW_NAVBAR_CLASS = 'navigation--blog--visible';

const SHOW_SHOP_KETONE_BUTTON_CLASS = 'blog-shop-ketone-button--visible';
const HIDDEN_SHOP_KETONE_BUTTON_CLASS = 'blog-shop-ketone-button--hidden';

export default class MobileNavigation {
  sideMenu = new SideMenu();
  menuContainerId = 'mobile-side-menu-container';
  menuItemExpandedClass = 'navigation__mobile-side-menu-item--expanded';
  menuWithSubItems = document.getElementsByClassName('js-menu-item-with-sub-items');
  burger = document.getElementById('navigation-burger');
  close = document.getElementById('mobile-navigation-close');
  bar = document.getElementById('mobile-navigation-bar');
  products = document.getElementById('mobile-navigation-products');
  learn = document.getElementById('mobile-navigation-learn');
  kits = document.getElementById('mobile-navigation-kits');
  back = document.getElementById('mobile-navigation-back');
  support = document.getElementById('mobile-navigation-support');
  limitedEditions = document.getElementById('mobile-navigation-limited-editions');

  previousScrollPosition = 0;

  blogNavbarContainers = document.querySelectorAll(`.${BLOG_NAVBAR_CONTAINER}`);
  blogShopKetoneButton = document.querySelector(`.${BLOG_SHOP_KETONE_BUTTON}`);

  isBlogNavbarHidden = false;
  isBlogShopKetoneButtonHidden = false;

  showMenu = () => {
    this.sideMenu.show(this.menuContainerId);

    this.burger.classList.add('hidden');
    this.close.classList.remove('hidden');

    if (this.back) {
      this.back.classList.add('hidden');
    }

    if (this.bar) {
      this.bar.classList.add('navigation--bordered');
    }
  };

  closeMenu = () => {
    this.sideMenu.hide(this.menuContainerId);

    this.burger.classList.remove('hidden');
    this.close.classList.add('hidden');

    if (this.back) {
      this.back.classList.add('hidden');
    }

    if (this.bar) {
      this.bar.classList.remove('navigation--bordered');
    }
  };

  toggleMenuItem = ({ target }) => {
    const parentLink = target.closest('a');

    if (!parentLink) {
      const menuItem = target.closest('.js-menu-item-with-sub-items');
      const productLinksContainer = menuItem.parentElement;
      const topLevelContainer = productLinksContainer.parentElement;

      if (menuItem.classList.contains(this.menuItemExpandedClass)) {
        topLevelContainer.scroll({ top: 0, behavior: 'smooth' });
        productLinksContainer.style.height = null;
        menuItem.classList.remove(this.menuItemExpandedClass);
      } else {
        if (topLevelContainer.offsetHeight > menuItem.offsetHeight) {
          productLinksContainer.style.height =
            `${productLinksContainer.offsetHeight + (topLevelContainer.offsetHeight - menuItem.offsetHeight)}px`;
        }
        topLevelContainer.scroll({ top: menuItem.offsetTop - productLinksContainer.offsetTop, behavior: 'smooth' });
        menuItem.classList.add(this.menuItemExpandedClass);
      }
    }
  };

  openSubMenu = (containerId) => () => {
    this.sideMenu.hide(this.menuContainerId);
    this.sideMenu.show(containerId);

    this.burger.classList.add('hidden');
    this.close.classList.add('hidden');

    if (this.back) {
      this.back.classList.remove('hidden');
      this.back.addEventListener('click', () => {
        this.sideMenu.hide(containerId);
        this.showMenu();
      }, { once: true });
    }
  };

  handeScroll = () => {
    const currentScrollPosition = window.scrollY;
    const previousScrollPosition = this.previousScrollPosition || 0;
    const direction = currentScrollPosition > previousScrollPosition ? Scroll.down : Scroll.up;

    this.previousScrollPosition = currentScrollPosition;

    if (direction === Scroll.down && currentScrollPosition > SCROLL_AMOUNT_TO_HIDE_NAVBAR) {
      this.blogNavbarContainers.forEach((blogNavbarContainer) => {
        blogNavbarContainer.classList.remove(SHOW_NAVBAR_CLASS);
        blogNavbarContainer.classList.add(HIDDEN_NAVBAR_CLASS);
      });
      this.blogShopKetoneButton.classList.remove(SHOW_SHOP_KETONE_BUTTON_CLASS);
      this.blogShopKetoneButton.classList.add(HIDDEN_SHOP_KETONE_BUTTON_CLASS);
      this.isBlogNavbarHidden = true;
      this.isBlogShopKetoneButtonHidden = true;
    } else if (direction === Scroll.up && this.isBlogNavbarHidden && this.isBlogShopKetoneButtonHidden) {
      this.blogNavbarContainers.forEach((blogNavbarContainer) => {
        blogNavbarContainer.classList.remove(HIDDEN_NAVBAR_CLASS);
        blogNavbarContainer.classList.add(SHOW_NAVBAR_CLASS);
      });
      this.blogShopKetoneButton.classList.remove(HIDDEN_SHOP_KETONE_BUTTON_CLASS);
      this.blogShopKetoneButton.classList.add(SHOW_SHOP_KETONE_BUTTON_CLASS);
      this.isBlogNavbarHidden = false;
      this.isBlogShopKetoneButtonHidden = false;
    }
  };

  initializeEventListeners = () => {
    document.addEventListener('open-cart', this.closeMenu);
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-side-menu-overlay')) {
        this.closeMenu();
      }
    });

    if (window.location.pathname.includes('/blogs')) {
      document.addEventListener('scroll', this.handeScroll);
    }

    if (this.burger) {
      this.burger.addEventListener('click', this.showMenu);
    }

    if (this.close) {
      this.close.addEventListener('click', this.closeMenu);
    }

    if (this.products) {
      this.products.addEventListener('click', this.openSubMenu('mobile-side-menu-products'));
    }

    if (this.learn) {
      this.learn.addEventListener('click', this.openSubMenu('mobile-side-menu-learn'));
    }

    if (this.kits) {
      this.kits.addEventListener('click', this.openSubMenu('mobile-side-menu-kits'));
    }

    if (this.support) {
      this.support.addEventListener('click', this.openSubMenu('mobile-side-menu-support'));
    }

    if (this.limitedEditions) {
      this.limitedEditions.addEventListener('click', this.openSubMenu('mobile-side-menu-limited-editions'));
    }
  };
}
